import { NgModule } from '@angular/core';
import { SITE_SELECTOR_NAMESPACE } from '@epicuro-next/constants/rule-engine/site-selector-rules';
import { AccountsDataModule } from '@epicuro-next/data/accounts';
import { ConfigurationModule } from '@epicuro-next/platform/configuration';
import {
  BROWSER_STORAGE_SERVICE,
  BROWSER_STORAGE_TOKEN,
} from '@epicuro-next/platform/storage';
import {
  resetStateMetaReducer,
  storageMetaReducer,
} from '@epicuro-next/state/meta-reducers';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import {
  sitesFeatureKey,
  SITES_META_REDUCER_TOKEN,
  SITES_STORAGE_KEYS_TO_SAVE_TOKEN,
  SITES_STORAGE_KEY_TOKEN,
} from './constants';
import { RouteEffects } from './state/effects/router.effects';
import { SitesEffects } from './state/effects/sites.effects';
import {
  currentAccountSites,
  initialState,
  preloadSites,
  reducer,
} from './state/sites.reducer';

export function getSitesFactoryConfig(
  saveKeys: string[],
  browserStorageKey: string,
  storageService: BROWSER_STORAGE_SERVICE,
) {
  return {
    metaReducers: [
      storageMetaReducer(saveKeys, browserStorageKey, storageService),
      resetStateMetaReducer(initialState),
    ],
  };
}

@NgModule({
  imports: [
    AccountsDataModule,
    StoreModule.forFeature(sitesFeatureKey, reducer, SITES_META_REDUCER_TOKEN),
    EffectsModule.forFeature([SitesEffects, RouteEffects]),
    ConfigurationModule.forFeature(SITE_SELECTOR_NAMESPACE),
  ],
  providers: [
    {
      provide: SITES_STORAGE_KEY_TOKEN,
      useValue: 'sites_storage',
    },
    {
      provide: SITES_STORAGE_KEYS_TO_SAVE_TOKEN,
      useValue: [currentAccountSites, preloadSites],
    },
    {
      provide: SITES_META_REDUCER_TOKEN,
      deps: [
        SITES_STORAGE_KEYS_TO_SAVE_TOKEN,
        SITES_STORAGE_KEY_TOKEN,
        BROWSER_STORAGE_TOKEN,
      ],
      useFactory: getSitesFactoryConfig,
    },
  ],
})
export class StateSitesStateModule {}
